// test2002
(2002 && 0);
